/**
 * Omits keys in an object
 *
 * @param {T} obj
 * @param {readonly K[]} keys
 * @returns {Omit<T, K>} The object with the specified keys omitted
 *
 * @example
 * const someObject = { foo: "bar", hello: "world", someKey: 123 }
 * omit(someObject, ["foo", "someKey", "noMatch"]); // { hello: "world" }
 */
export function omit<T extends object, K extends keyof T>(
  obj: T,
  keys: readonly K[],
): Omit<T, K> {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key as K)),
  ) as Omit<T, K>;
}
